import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PerfilRiesgo } from '../../_models/perfil-riesgo';
import {ConfirmationService, SelectItem} from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PerfilRiesgoVariacionMontoService } from '../../_services/perfil-riesgo-variacion-monto.service';
import { PerfilRiesgoVariacionMonto } from '../../_models/perfil-riesgo-variacion-monto';
import {Modalidad} from '../../_models/modalidad';
import {forkJoin} from 'rxjs';
import {ModalidadService} from '../../_services/modalidad.service';
import {SegmentoActivo} from '../../_models/segmento-activo';

@Component( {
  selector: 'app-perfiles-riesgo-tasa',
  templateUrl: 'perfiles-riesgo-tasa.component.html'
} )

export class PerfilesRiesgoTasaComponent implements OnInit {

  @Input() perfil: PerfilRiesgo;
  @Output() dismiss: EventEmitter<string> = new EventEmitter();
  columnas: any[] = [];
  lisPerfilesRiesgoTasas: PerfilRiesgoVariacionMonto[] = [];
  carInformacionInicial = true;
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  supTasa = false;
  ranIncorrecto = false;
  lisModalidad: SelectItem[] = [];
  lisTodosModalidad: Modalidad[] = [];
  carRiesgoTasa: boolean;

  constructor( private perRiesgoTasaServicio: PerfilRiesgoVariacionMontoService,
               private conServicio: ConfirmationService,
               private nav: NavService,
               private fb: FormBuilder,
               private modalidadadServices: ModalidadService) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'nombreModalidad', header: this.nav.buscarMensaje( 'PERFILRIESGOTASAS.LBL_MODALIDAD' ), sort: false },
      { field: 'tasaModalidad', header: this.nav.buscarMensaje( 'PERFILRIESGOTASAS.LBL_TASAEA' ), sort: false },
      { field: 'tasaPeriodica', header: this.nav.buscarMensaje( 'PERFILRIESGOTASAS.LBL_TASAPERIODICA' ), sort: false },
      { field: 'puntosDisminucion', header: this.nav.buscarMensaje( 'PERFILRIESGOTASAS.LBL_PUNTODISMINUCION' ), sort: false },
      { field: 'montoMinimo', header: this.nav.buscarMensaje( 'PERFILRIESGOTASAS.LBL_MONTOMINIMO' ), sort: false },
      { field: 'montoMaximo', header: this.nav.buscarMensaje( 'PERFILRIESGOTASAS.LBL_MONTOMAXIMO' ), sort: false },
      { field: 'det', header: this.nav.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    forkJoin(
      this.perRiesgoTasaServicio.listadoPorPerfilRiesgo( this.perfil.idPerfilRiesgo ),
      this.modalidadadServices.listadoModalidadesHabilitadas()
    ).subscribe( ( [ lisPerfilesTasas, modalidades ] ) => {
      this.lisPerfilesRiesgoTasas = lisPerfilesTasas.filter( x => x.indicadorHabilitado );
      this.cargarFormulario();
      //this.ordennarLista();
      this.lisTodosModalidad = modalidades;
      modalidades.map( ( s: Modalidad ) => {
        this.lisModalidad.push( { label: s.nombre, value: s.idModalidad } );
      } );
      this.carInformacionInicial = false;
    } );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idPerfilRiesgoVariacionMonto: [ null ],
      idModalidad: [ null, [ Validators.required ] ],
      tasaModalidad: [ null, [ Validators.required ]],
      tasaPeriodica: [ null, [ Validators.required ]],
      puntosDisminucion: [ null, [ Validators.required, Validators.maxLength( 5 ) ] ],
      montoMinimo: [null, [ Validators.required, Validators.maxLength( 6 ) ] ],
      montoMaximo: [ null, [ Validators.required, Validators.maxLength( 6 ) ] ],
      idPerfilRiesgo: [ this.perfil.idPerfilRiesgo, [ Validators.required ] ],
      indicadorSuma: [ false, [ Validators.required ] ],
      indicadorHabilitado: [ true ],
      auditoriaFecha: [ null ],
      auditoriaUsuario: [ null ],
    } );
  }

  onSubmit() {
    this.submitted = true;
    this.validarRango();
    if ( this.formulario.valid && ! this.supTasa && ! this.ranIncorrecto ) {
      this.guardando = true;
      this.carRiesgoTasa = true;
      const perRiesgoTasa = this.formulario.value;
      this.perRiesgoTasaServicio.crear( perRiesgoTasa ).subscribe( perRiesgoTasa => {
        perRiesgoTasa.idPerfilRiesgoVariacionMonto = perRiesgoTasa.idPerfilRiesgoVariacionMonto;
        const b = this.lisTodosModalidad.find( x => x.idModalidad === perRiesgoTasa.idModalidad );
        if ( b ) {
          perRiesgoTasa.nombreModalidad = b.nombre;
          perRiesgoTasa.tasaModalidad = b.tasa;
          perRiesgoTasa.tasaPeriodica = this.f.tasaPeriodica.value / 100;
        }
        this.lisPerfilesRiesgoTasas.push( perRiesgoTasa );
        this.submitted = false;
        this.formulario.reset();
        this.f.idPerfilRiesgo.setValue( this.perfil.idPerfilRiesgo );
        this.f.indicadorHabilitado.setValue( true );
        this.f.indicadorSuma.setValue( false );
        this.guardando = false;
        this.carRiesgoTasa = false;
        this.nav.setMesage( 1 );
      }, error => {
        this.guardando = false;
        this.carRiesgoTasa = false;
        this.nav.setMesage( 3 );
      } );
    }
  }

  deshabilitar( perRiesgoTasa: PerfilRiesgoVariacionMonto ) {
    this.carInformacionInicial = true;
    perRiesgoTasa.indicadorHabilitado = false;
    this.perRiesgoTasaServicio.actualizar( perRiesgoTasa ).subscribe( tasa => {
      const indice = this.lisPerfilesRiesgoTasas.findIndex( x => x.idPerfilRiesgoVariacionMonto === perRiesgoTasa.idPerfilRiesgoVariacionMonto );
      if ( indice >= 0 ) {
        this.lisPerfilesRiesgoTasas.splice( indice, 1 );
      }
      this.submitted = false;
      this.formulario.reset();
      this.f.idPerfilRiesgo.setValue( this.perfil.idPerfilRiesgo );
      this.f.indicadorHabilitado.setValue( true );
      this.f.indicadorSuma.setValue( false );

      this.carInformacionInicial = false;
    } );
  }

  irSiguiente() {
    this.dismiss.emit( 'CICLO' );
  }

  get f() {
    return this.formulario.controls;
  }

  validarTasa() {
    const punDisminucion = Number( this.f.puntosDisminucion.value );
    if ( this.f.idModalidad.value ) {
      const tasa = this.lisTodosModalidad.find(x=> x.idModalidad === this.f.idModalidad.value);
      this.supTasa = (punDisminucion > tasa.tasa) ? true : false;
    } else {
      this.supTasa = true;
    }
  }

  validarRango() {
    const inferior = Number( this.f.montoMinimo.value );
    const superior = Number( this.f.montoMaximo.value );
    this.ranIncorrecto = ( inferior && (superior || superior === 0) && inferior >= superior ) ? true : false;
  }

  obtenerMaximo( ): number {
    let maximo = 0;
    if ( this.f.idModalidad.value ){
      const listado = this.lisPerfilesRiesgoTasas.filter(li => li.idModalidad === this.f.idModalidad.value);
      listado.map( ( s: PerfilRiesgoVariacionMonto ) => {
        const a = Number( s.montoMaximo );
        if ( a > maximo ) {
          maximo = a;
        }
      } );
    }
    return maximo;
  }

  validarModalidad(){
    const idModalidad = Number( this.f.idModalidad.value );
    if ( this.f.idModalidad.value ){
      const maximo = this.obtenerMaximo();
      const tasa = this.lisTodosModalidad.find(x=> x.idModalidad === this.f.idModalidad.value);
      this.f.tasaModalidad.setValue(tasa.tasa);
      const base = Number(1 + Number(tasa.tasa) * 0.01 );
      const exponente = Number(30 / 360);
      const tasaPeriodica =  (Math.pow( base, exponente ) - 1) * 100;
      this.f.tasaPeriodica.setValue(tasaPeriodica);
      this.f.montoMinimo.setValue(maximo);
      this.f.puntosDisminucion.setValue(null);
      this.f.montoMaximo.setValue(null);
    }
  }

  ordenarLista(lista: any[]): any[]{
    lista.sort(function (a, b) {
      if (a.idModalidad > b.idModalidad) {
        return 1;
      }
      if (a.idModalidad < b.idModalidad) {
        return -1;
      }
      return 0;
    });
    return lista;
  }

  get getPerfilesRiesgoTasas() {
    return this.ordennarLista(this.lisPerfilesRiesgoTasas);
  }

  ordennarLista(lista: any[]): any[]{
    if(lista.length >0){
      lista = this.ordenarLista(lista);
      let modalidadSiguiente = lista[0].idModalidad;
      let index = 0;
      lista.map( ( s: PerfilRiesgoVariacionMonto ) => {
        index++;
        if(index > (lista.length - 1) ){
          index = lista.length - 1;
        }
        modalidadSiguiente = lista[index].idModalidad;
        s.indicadorEliminar = false;
        if(modalidadSiguiente !== s.idModalidad){
          s.indicadorEliminar = true;
        }
      });
    }
    return lista;
  }

}
